import React, { Component } from 'react';

import { StampAPI, StampIcon } from '@philips-emr/tws-components-api';
import { Color } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, expression, oneOf, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, isEnumValid } from '@philips-emr/tws-utils';
import './stamp.scss';

import { ReactComponent as CancelIcon } from '../../../resources/assets/components/status/cancel.svg';
import { ReactComponent as CheckIcon } from '../../../resources/assets/components/status/check.svg';
import { ReactComponent as LocaleIcon } from '../../../resources/assets/components/status/locale.svg';
import { ReactComponent as MissedIcon } from '../../../resources/assets/components/status/missed.svg';
import { ReactComponent as TimeIcon } from '../../../resources/assets/components/status/time.svg';
import { ReactComponent as WarningIcon } from '../../../resources/assets/components/status/warning.svg';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: StampAPI })
class Stamp extends Component {
  static propTypes = {
    color: oneOf(enumValues(Color)),
    enableAutoHide: bool,
    icon: oneOf(enumValues(StampIcon)),
    label: expression,
    className: string,
  };

  static defaultProps = {
    color: Color.SAFETY_NEUTRAL,
  };

  getIcon(name) {
    const icons = {
      [StampIcon.CHECK]: CheckIcon,
      [StampIcon.WARNING]: WarningIcon,
      [StampIcon.CANCELED]: CancelIcon,
      [StampIcon.CANCELED_OUTLINE]: MissedIcon,
      [StampIcon.CLOCK]: TimeIcon,
      [StampIcon.LOCALE]: LocaleIcon,
    };

    return icons[name] || null;
  }

  getRootClasses() {
    const { className } = this.props;

    const rootClasses = {
      'c-stamp': true,
      [className]: className,
    };

    return classNames(rootClasses);
  }

  getIconClasses() {
    const { color = '' } = this.props;

    const iconClasses = {
      'c-stamp__icon': true,
      [`u-color-${color.replace('_', '-')}`]: isEnumValid(Color, color),
    };

    return classNames(iconClasses);
  }

  getLabelClasses() {
    const { enableAutoHide } = this.props;

    const labelClasses = {
      'c-stamp__label': true,
      'u-truncate': true,
      'u-hide@xsm': enableAutoHide,
    };

    return classNames(labelClasses);
  }

  render() {
    const { icon, label } = this.props;

    const StampIcon = this.getIcon(icon);

    return (
      <div className={this.getRootClasses()}>
        {StampIcon &&
        <div className={this.getIconClasses()} x-contrast="cl">
          <StampIcon />
        </div>}

        {label &&
        <span className={this.getLabelClasses()}>{msg(label)}</span>}
      </div>
    );
  }
}

export default Stamp;
